import BaseEvent from './base_event';

export default class LooseEvent extends BaseEvent {
    static canOccur(gameState) {
        return gameState.howMuchTimeToFly() === 0 
            && gameState.availableItemsOnShip().length === 0
            && gameState.stoppedTime > 5000 
            && gameState.eventsResults.lastChance 
            && gameState.eventsResults.lastChance.left === 0;
    }

    enter(gameState) {
        if (typeof ga === "function") ga('send', 'event', 'game', 'LooseEvent');

        this.ui.showDialog({
            message: "Well, there goes your last chance of survival. Looks like this is the end. It was an honor, captain.\n\nAt least until you've burned your pants.",
            options: [{text: "Damn..."}]
        }, () => {
            game.gameState.loose("noenergy");
            game.state.start("win");
        });
    }
}


// WEBPACK FOOTER //
// ./src/states/events/loose_event.js